import { FC } from "react"
import { SchedulesConfirmDelete } from "../../../module/schedules/containers/confirmDelete"

export const SchedulesConfirmDeletePage: FC = () => <SchedulesConfirmDelete />
